import { Injectable } from '@angular/core';
import { TcmModalService } from '../modules/tcm-common/services/tcm-modal.service';
import { SalesOrderDataService } from './sales-order-data.service';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})
export class SerializedItemProcessService {
  constructor(private readonly salesOrderDataService: SalesOrderDataService,
    private readonly translationService: TranslationService,
    private readonly modalService: TcmModalService) {
  }

  public async changeReceivedRepairsToReadyForDeliveryIfNeededAsync(serialNumber: string, cancellationToken: Promise<any>): Promise<boolean> {    
      let hasActiveReceivedRepairInSaleOrder = false;

      let receivedRepairsSaleOrderNumber: number = null;

      if (serialNumber) {
        receivedRepairsSaleOrderNumber = await this.salesOrderDataService.getReceivedRepairsOrderNumberAsync(serialNumber, cancellationToken);
      }

      if (receivedRepairsSaleOrderNumber) {
        hasActiveReceivedRepairInSaleOrder = true;
        const message = this.translationService.translate(x => x.Messages.WarningMessages.SerialNumberHasOpenRepairOrderNumber)
          .replace("{0}", receivedRepairsSaleOrderNumber);

        const isConfirmed = await this.modalService.showConfirmationModalAsync(x => x.Messages.MessageHeadersAndActions.Warning, message);

        if (isConfirmed) {
          await this.salesOrderDataService.changeReceivedRepairsToReadyForDeliveryAsync(serialNumber, cancellationToken);
        }
      }

      return hasActiveReceivedRepairInSaleOrder;    
  }
}
